import React from 'react';

// Types
import { UserSuggestion, UserSuggestionType } from 'Shared/types/UserSuggestion.type';

// Components
import ProvideKudosSuggestion from './_partials/ProvideKudosSuggestion';
import FeedbackDraftReminderSuggestion from './_partials/FeedbackDraftReminderSuggestion';
import GoalReminderSuggestion from './_partials/GoalReminderSuggestion';
import PrepareForMeetingSuggestion from './_partials/PrepareForMeetingSuggestion';
import ProvideFeedbackSuggestion from './_partials/ProvideFeedbackSuggestion';

type Props = {
  userSuggestion: UserSuggestion;
  className?: string;
};

const UserSuggestionsListItem = ({ userSuggestion, className }: Props) => {
  const type = userSuggestion.type;

  switch (type) {
    case UserSuggestionType.provideKudos:
      return <ProvideKudosSuggestion userSuggestion={userSuggestion} className={className} />;
    case UserSuggestionType.feedbackDraftReminder:
      return <FeedbackDraftReminderSuggestion userSuggestion={userSuggestion} className={className} />;
    case UserSuggestionType.goalReminder:
      return <GoalReminderSuggestion userSuggestion={userSuggestion} className={className} />;
    case UserSuggestionType.prepareForMeeting:
      return <PrepareForMeetingSuggestion userSuggestion={userSuggestion} className={className} />;
    case UserSuggestionType.provideFeedback:
      return <ProvideFeedbackSuggestion userSuggestion={userSuggestion} className={className} />;
    default:
      return null;
  }
};

export default UserSuggestionsListItem;
